// delay waits `t` milliseconds then resolves the promise
// export function delay<T>(t: number, val?: T): Promise<T> {
//   return new Promise((resolve, reject) => {
//     setTimeout(resolve, t, val);
//   });
// }
// hannWindow returns the left half of a hann window (from 0 to 1) over n samples
function hannWindow(n) {
    if (n < 2) {
        throw Error('invalid argument');
    }
    var res = new Array(n);
    for (var i = 0; i < n; i += 1) {
        // eslint-disable-next-line
        res[i] = 0.5 * (1 - Math.cos((Math.PI * i) / (n - 1)));
    }
    return res;
}
var hannRampUp = (function () {
    var h = [];
    return function () {
        if (h.length === 0) {
            h = hannWindow(64);
        }
        return h;
    };
})();
var hannRampDown = (function () {
    var h = [];
    return function () {
        if (h.length === 0) {
            h = hannRampUp().slice().reverse();
        }
        return h;
    };
})();
// hanningRampInOut adds a hann ramp fade in and out to a playing buffer
export function hanningRampInOut(node, rampTime, maxGain) {
    try {
        var mGain_1 = maxGain || 1;
        var hUp = new Float32Array(hannRampUp().map(function (v) { return v * mGain_1; }));
        // console.log("ramp up:", hUp);
        node.gain.gain.setValueCurveAtTime(hUp, node.start, rampTime);
        if (node.stop) {
            var hDown = new Float32Array(hannRampDown().map(function (v) { return v * mGain_1; }));
            // console.log("ramp down:", hDown);
            node.gain.gain.setValueCurveAtTime(hDown, node.stop - rampTime, rampTime);
        }
    }
    catch (e) {
        console.warn("hanningRampInOut err: ".concat(e));
    }
}
